module.exports = __webpack_public_path__ + "static/americanbanker-2135c01f92d28841258b989956d55084.png";